module.exports = __webpack_public_path__ + "static/media/paket1New.e056d06b.jpg";